import React from 'react'
import Checkbox from '@material-ui/core/Checkbox'

import List from '@material-ui/core/List'
import ListItem from '@material-ui/core/ListItem'
import ListItemText from '@material-ui/core/ListItemText'
import ListItemSecondaryAction from '@material-ui/core/ListItemSecondaryAction'

import { Set } from 'immutable'

import { MinimalContactFragment } from 'src/graphql'

interface Props {
  contacts: MinimalContactFragment[]
  isEveryContactSelected: boolean
  onSelectAll: () => void
  onSelect: (id: string) => void
  selected: Set<string>
}

const ContactSelector = (props: Props) => {
  const {
    contacts,
    onSelect,
    onSelectAll,
    isEveryContactSelected,
    selected,
  } = props
  return (
    <div
      style={{
        overflowY: 'auto',
        maxHeight: '300px',
        borderBottom: '1px solid #3b4045',
      }}
    >
      <List>
        <ListItem>
          <ListItemText primary={'Select All'} />
          <ListItemSecondaryAction>
            <Checkbox checked={isEveryContactSelected} onChange={onSelectAll} />
          </ListItemSecondaryAction>
        </ListItem>
        {contacts.map(contact => {
          const { id, firstName, lastName } = contact

          return (
            <ListItem key={id}>
              <ListItemText primary={`${firstName} ${lastName}`} />
              <ListItemSecondaryAction>
                <Checkbox
                  checked={selected.has(id)}
                  onChange={() => onSelect(id)}
                />
              </ListItemSecondaryAction>
            </ListItem>
          )
        })}
      </List>
    </div>
  )
}

export default ContactSelector
